import type { LeaseActionProps } from '../../../models/Types';

export default function RedirectToLeaseRoot({ lease, history, terminateActiveAction }: LeaseActionProps) {
  history.push(lease.getRootPath());
  terminateActiveAction();
  return null;
}
